import React from 'react';
import { SelectInput } from 'react-admin';

const statusChoices = [
    { id: 'draft', name: 'Draft' },
    { id: 'todo', name: 'Todo' },
    { id: 'in_progress', name: 'In Progress' },
    { id: 'paused', name: 'Paused' },
    { id: 'done', name: 'Done' },
    { id: 'canceled', name: 'Canceled' }
];

const StatusInput = (props) => (
    <SelectInput
        source="status"
        choices={statusChoices}
        defaultValue="draft"
        {...props}
    />
);

export default StatusInput;
